import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { EditReturnedRefundModal, ReviewRefundRequestModal } from '../../components';

const includesArr = (arr1, arr2) => arr1.some(item => arr2.includes(item))

export default class RefundViewer extends Component {
  static propTypes = {
    userRoles: Proptypes.array,
    ticket: Proptypes.object,
    fetchTicket: Proptypes.func,
    close: Proptypes.func,
    getRefundsCount: Proptypes.func,
    addComment: Proptypes.func,
    getOperatorData: Proptypes.func,
    operators: Proptypes.array,
    uploadFiles: Proptypes.func,
    uploading: Proptypes.bool,
    match: Proptypes.object,
    updateReturnedRefund: Proptypes.func,
    getTransactions: Proptypes.func
  }

  componentDidMount() {
    this.props.getOperatorData();
    this.props.fetchTicket(this.props.match.params.id);
  }

  render() {
    if (
      this.props.operators &&
      this.props.operators.length &&
      this.props.ticket &&
      this.props.ticket.status === 'RETURNED' &&
      includesArr(this.props.userRoles, ['SU', 'MGMT', 'CC_LEVEL_1', 'CC_LEVEL_1_AE', 'CC_LEVEL_1_US'])
    ) {
      return (
        <EditReturnedRefundModal
          close={() => this.props.history.push('/')}
          operators={this.props.operators}
          addComment={this.props.addComment}
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          getRefundsCount={this.props.getRefundsCount}
          open={this.props.match.params.id}
          initialValues={this.props.ticket}
          updateStatus={this.props.updateReturnedRefund}
          getTransactions={this.props.getTransactions}
          transactions={this.props.transactions}
        />
      );
    } else if (
      this.props.operators &&
      this.props.operators.length &&
      this.props.ticket &&
      this.props.ticket.status === 'REQUESTED' &&
      includesArr(this.props.userRoles, ['SU', 'MGMT', 'CC_APPROVER', 'CC_APPROVER_AE', 'CC_APPROVER_US'])
    ) {
      return (
        <ReviewRefundRequestModal
          close={() => this.props.history.push('/')}
          operators={this.props.operators}
          addComment={this.props.addComment}
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          getRefundsCount={this.props.getRefundsCount}
          open={this.props.match.params.id}
          initialValues={this.props.ticket}
          updateStatus={this.props.updateStatus}
          refundCount={this.props.refundCount}
          getTransactions={this.props.getTransactions}
          transactions={this.props.transactions}
        />
      );
    } else if (
      this.props.operators &&
      this.props.operators.length &&
      this.props.ticket &&
      (this.props.ticket.status === 'APPROVED' || this.props.ticket.status === 'COMPLETED') &&
      includesArr(this.props.userRoles, ['SU', 'MGMT', 'CC_MANAGER', 'CC_MANAGER_AE', 'CC_MANAGER_US'])
    ) {
      return (
        <ReviewRefundRequestModal
          close={() => this.props.history.push('/')}
          operators={this.props.operators}
          addComment={this.props.addComment}
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          getRefundsCount={this.props.getRefundsCount}
          open={this.props.match.params.id}
          initialValues={this.props.ticket}
          updateStatus={this.props.updateStatus}
          refundCount={this.props.refundCount}
          type="manager"
          getTransactions={this.props.getTransactions}
          transactions={this.props.transactions}
        />
      );
    } else if (
      this.props.operators &&
      this.props.operators.length &&
      this.props.ticket &&
      Object.keys(this.props.ticket).length
    ) {
      return (
        <ReviewRefundRequestModal
          close={() => this.props.history.push('/')}
          operators={this.props.operators}
          addComment={this.props.addComment}
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          getRefundsCount={this.props.getRefundsCount}
          open={this.props.match.params.id}
          initialValues={this.props.ticket}
          updateStatus={this.props.updateStatus}
          refundCount={this.props.refundCount}
          type="requestor"
          getTransactions={this.props.getTransactions}
          transactions={this.props.transactions}
          loadingTransactions={this.props.loadingTransactions}
        />
      );
    } else {
      return <div className="loading-widget-dimmer">
            <div className="loading-widget loading-widget_main">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <g fill="none" fill-rule="evenodd">
                        <path className="loading-widget__draw-animation" stroke="#4061AD" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M19.783 5.792V.793c0-.581-.476-.82-1.057-.555L6.137 6.188c-.582.265-1.058.952-1.058 1.534v20.972c0 .582.476.82 1.058.556l13.62-6.427-4.655 2.222V13.488l-2.565 1.269v-5.58l7.246-3.385z"/>
                        <path className="loading-widget__draw-animation" stroke="#14AFE4" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M26.21 2.75L18.435 6.4l1.322-.635V22.77l-4.655 2.195V13.488l-2.538 1.269v16.45c0 .581.476.82 1.057.555l12.589-5.924c.582-.264 1.058-.952 1.058-1.534V3.332c0-.608-.476-.846-1.058-.582z"/>
                    </g>
                </svg>
            </div>
             </div>
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/RefundViewerComponent/RefundViewer.js